// extracted by mini-css-extract-plugin
module.exports = {"photo":"Boat_photo__282Qm","main":"Boat_main__2P4Oe","title":"Boat_title__22hb5","rating":"Boat_rating__ijc-V","icon":"Boat_icon__rGdWF"};